// import { Navbar, Nav, Container } from "react-bootstrap";
// import { LinkContainer } from "react-router-bootstrap";
// import "./Header.css";
// import Logo from "../assets/images/logo.png";
// import Scrollspy from "react-scrollspy";

// const sections = [
//   { name: "Popular Products", id: "section-1" },
//   { name: "Wall Decoratives", id: "section-2" },
//   { name: "Desk Decoratives", id: "section-3" },
//   { name: "Personalized Section", id: "banner" },
//   { name: "Themed Events", id: "section-5" },
//   { name: "Kids favourites", id: "section-5-kids" },
//   { name: "Business Section", id: "section-6" },
//   { name: "Digital Printing", id: "section-6-d" },
//   { name: "Promotional Boards", id: "section-6-boards" },
//   { name: "Flex Printing", id: "section-6-flex" },
//   { name: "Office Stationary", id: "section-6-office" },
//   { name: "Why Us?", id: "section-7" },
//   { name: "Contact", id: "section-9" },
// ];

// const Header = () => {
//   const scrollToSection = (id) => {
//     const section = document.getElementById(id);
//     if (section) {
//       const navbarHeight = document.querySelector(".navbar").offsetHeight;
//       const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//       const extraOffset = 20;
//       window.scrollTo({
//         top: sectionTop - navbarHeight - extraOffset,
//         behavior: "smooth",
//       });
//     }
//   };

//   return (
//     <>
//       {/* Banner */}
//       <marquee className="no-gap top-banner">
//         Contact for Orders and Inquiries: +91 9814067069
//       </marquee>

//       {/* Navbar */}
//       <Navbar
//         expand="lg"
//         variant="dark"
//         collapseOnSelect
//         style={{
//           backgroundColor: "#006D77",
//           marginTop: "0",
//           lineHeight: "normal",
//           padding: "0",
//           position: "sticky",
//           top: "2.4rem",
//           zIndex: "1020",
//         }}
//         className="no-gap p-0"
//       >
//         <Container>
//           <LinkContainer to="/">
//             <Navbar.Brand style={{ display: "flex", flexDirection: "row" }}>
//               <img
//                 src={Logo}
//                 style={{ height: "70px", width: "70px" }}
//                 className="logo"
//                 alt="Shagan Arts Logo"
//               />
//             </Navbar.Brand>
//           </LinkContainer>
//           <div className="logo-content">
//             <span className="logo-text">Shagan Arts</span>
//             <br />
//             <span className="logo-text-extra">
//               &nbsp; &nbsp; Beyond The Printing...
//             </span>
//           </div>
//           <Navbar.Toggle aria-controls="basic-navbar-nav" />
//           <Navbar.Collapse id="basic-navbar-nav">
//             <Nav className="ml-auto nav-links">
//               <LinkContainer to="/">
//                 <Nav.Link>Home</Nav.Link>
//               </LinkContainer>
//               <LinkContainer to="/services">
//                 <Nav.Link>Services</Nav.Link>
//               </LinkContainer>
//               <LinkContainer to="/about">
//                 <Nav.Link>About Us</Nav.Link>
//               </LinkContainer>
//               <LinkContainer to="/contact">
//                 <Nav.Link>Contact Us</Nav.Link>
//               </LinkContainer>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>

//       {/* Scrollspy Banner */}
//       <div className="scroll-banner-section">
//         <div className="scroll-container">
//           {sections.map((section, index) => (
//             <div
//               key={index}
//               className="scroll-item"
//               onClick={() => scrollToSection(section.id)}
//               style={{ cursor: "pointer" }}
//             >
//               {section.name}
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;

import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./Header.css";
import Logo from "../assets/images/logo.png";
// import Marquee from "react-fast-marquee";

const sections = [
  { name: "Popular Products", id: "section-1" },
  { name: "Wall Decoratives", id: "section-2" },
  { name: "Desk Decoratives", id: "section-3" },
  { name: "Personalized Section", id: "banner" },
  { name: "Themed Events", id: "section-5" },
  { name: "Kids favourites", id: "kids-favorite" },
  { name: "Business Section", id: "section-6" },
  { name: "Digital Printing", id: "section-6-d" },
  { name: "Promotional Boards", id: "section-6-boards" },
  { name: "Flex Printing", id: "section-6-flex" },
  { name: "Office Stationary", id: "section-6-office" },
  { name: "Why Us?", id: "section-7" },
  { name: "Contact", id: "section-9" },
];

const Header = () => {
  // Scroll to section function
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const navbarHeight = document.querySelector(".navbar").offsetHeight;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      const extraOffset = 20;
      window.scrollTo({
        top: sectionTop - navbarHeight - extraOffset,
        behavior: "smooth",
      });
    }
  };

  // Horizontal scroll control
  const scrollBanner = (direction) => {
    const container = document.querySelector(".scroll-container");
    const scrollAmount = 200;
    if (direction === "left") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <>
      {/* Banner */}
      <marquee className="no-gap top-banner">
        Contact for Orders and Inquiries: +91 9814067069
      </marquee>

      {/* <Marquee gradient={false} className="no-gap top-banner">
        Contact for Orders and Inquiries: +91 9814067069
      </Marquee> */}

      {/* Navbar */}
      <Navbar
        expand="lg"
        variant="dark"
        collapseOnSelect
        style={{
          backgroundColor: "#006D77",
          marginTop: "0",
          lineHeight: "normal",
          padding: "0",
          position: "sticky",
          top: "2.4rem",
          zIndex: "1020",
        }}
        className="no-gap p-0"
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand style={{ display: "flex", flexDirection: "row" }}>
              <img
                src={Logo}
                style={{ height: "70px", width: "70px" }}
                className="logo"
                alt="Shagan Arts Logo"
              />
            </Navbar.Brand>
          </LinkContainer>
          <div className="logo-content">
            <span className="logo-text">Shagan Arts</span>
            <br />
            <span className="logo-text-extra">
              &nbsp; &nbsp; Beyond The Printing...
            </span>
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto nav-links">
              <LinkContainer to="/">
                <Nav.Link>Home</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/services">
                <Nav.Link>Services</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/about">
                <Nav.Link>About Us</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/contact">
                <Nav.Link>Contact Us</Nav.Link>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Scrollspy Banner with Horizontal Scrolling */}
      <div className="scroll-banner-section">
        <button onClick={() => scrollBanner("left")} className="scroll-btn">
          &#8249; {/* Left arrow */}
        </button>
        <div className="scroll-container">
          {sections.map((section, index) => (
            <div
              key={index}
              className="scroll-item"
              onClick={() => scrollToSection(section.id)}
              style={{ cursor: "pointer" }}
            >
              {section.name}
            </div>
          ))}
        </div>
        <button onClick={() => scrollBanner("right")} className="scroll-btn">
          &#8250; {/* Right arrow */}
        </button>
      </div>
    </>
  );
};

export default Header;
